module.exports = __webpack_public_path__ + "assets/img/4.5b725b00.gif";